import "./Footer.scss";
// white drinktec logo without claim (redesign 2026; was the "Grow with the Flow" PNG)
import logoFooter from "./../../assets/logo_white.svg";

export interface FooterProps {
    date: string;
    isSmall: boolean;
}

function Footer(props: FooterProps) {
    if(props.isSmall) {
        return (
            <div className="Footer-Small">
                <span className="date">{props.date}</span>
                <span className="url">drinktec.com</span>
            </div>
        )
    } else {
        return (
            <div className="Footer-Big">
                <div className="brand">
                    <img src={logoFooter} />
                </div>
                <div className="info">
                    <div className="date">{props.date}</div>
                    <div className="url">drinktec.com</div>
                </div>
            </div>
        )
    }
}

export default Footer;